import React from 'react';
import PropTypes from 'prop-types';

import { bemGenerator } from '@prisjakt/ui-base';

import './panel-header.scss';

const styles = bemGenerator('pj-ui-panel-header', [
  'header',
  'title',
  'subtitle',
  'child-container',
]);

const PanelHeader = ({
  title,
  anchorId,
  subtitle,
  children,
  margin,
  divider,
  className,
}) => (
  <div id={anchorId} className={className} data-test="PanelHeader">
    <div
      className={styles.header.withModifier({
        'margin-top': ['top', 'both'].includes(margin),
        'margin-bottom': ['bottom', 'both'].includes(margin),
        'divider-top': ['top', 'both'].includes(divider),
        'divider-bottom': ['bottom', 'both'].includes(divider),
      })}
    >
      {(title || subtitle) && (
        <div>
          {title && (
            <h2
              className={styles.title.withModifier({
                'only-children': children && children.length > 0,
                'has-subtitle': subtitle && subtitle.length > 0,
              })}
            >
              {title}
            </h2>
          )}
          {subtitle && (
            <div
              data-test="PanelHeaderSubtitle"
              className={styles.subtitle.withModifier({
                'only-children': children && children.length > 0,
              })}
            >
              {subtitle}
            </div>
          )}
        </div>
      )}
      <div
        className={styles['child-container'].withModifier({
          'only-children': children && children.length > 0,
        })}
      >
        {React.Children.map(children, child => child)}
      </div>
    </div>
  </div>
);

PanelHeader.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  anchorId: PropTypes.string,
  subtitle: PropTypes.string,
  children: PropTypes.node,
  margin: PropTypes.oneOf(['top', 'bottom', 'both', 'none']),
  divider: PropTypes.oneOf(['top', 'bottom', 'both', 'none']),
  className: PropTypes.string,
};
PanelHeader.defaultProps = {
  title: null,
  subtitle: null,
  anchorId: null,
  children: null,
  margin: 'none',
  divider: 'top',
  className: undefined,
};

export default PanelHeader;
